import api from '..';
import useSWR from 'swr';

export const TargetedOfferFetch = (telefone: string) => {
  const { data, mutate, isLoading } = useSWR<string>(
    telefone ? `targeted_offer_${telefone}` : null,
    async (): Promise<string> => {
      const { data } = await api.get<string>(
        `/core/oferta-direcionada/${telefone}`,
      );
      return data;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return { data, mutate, isLoading };
};
